import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar]);

export default function ExcimerFacts() {
  // eslint-disable-next-line no-new
  new Swiper('.facts_banners .swiper', {
    direction: 'horizontal',
    rewind: true,
    slidesPerView: 2,
    preloadImages: false,
    spaceBetween: 22,
    draggable: true,
    pagination: {
      el: '.facts_banners .swiper-pagination',
      clickable: true,
      renderBullet(index, className) {
        return `<div class="pagination-dot ${className}"></div>`;
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },

  });
}
